import { MapPin, Phone, Mail } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { Reveal, Overline } from "@/components/motion";

export default function HomeOffices({ title, subtitle }) {
  const { settings } = useSettings();
  const offices = settings?.offices || [];
  if (!offices.length) return null;

  return (
    <section id="offices" data-testid="home-offices" className="relative py-24 sm:py-32 bg-[#faf7ee]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-14">
            <div className="flex justify-center"><Overline>{title || "Our Offices"}</Overline></div>
            <h2 className="font-serif text-[#3b1a1a] text-4xl sm:text-6xl leading-[1.03] tracking-tight mt-5">
              Meet us <span className="italic text-[#7c1d1d]">across India.</span>
            </h2>
            <p className="text-[#5a4b4b] mt-5 leading-relaxed">
              {subtitle || "Three offices, one promise — a warm welcome to every traveller."}
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {offices.map((o, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div
                data-testid={`home-office-${i}`}
                className="relative h-full bg-white border border-[#d4af37]/30 hover:border-[#d4af37] p-7 transition-colors group overflow-hidden"
              >
                <span className="absolute top-0 left-0 h-1 w-20 bg-[#7c1d1d] group-hover:w-full transition-[width] duration-500" />
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#14523d] font-semibold mt-2">
                  {o.label || "Office"}
                </div>
                <div className="font-serif text-2xl text-[#3b1a1a] mt-1 leading-tight">
                  {o.name || "Legacy India Travel"}
                </div>
                <div className="mt-5 flex items-start gap-3 text-[#4a4a4a] text-sm leading-relaxed">
                  <MapPin className="w-4 h-4 text-[#d4af37] shrink-0 mt-0.5" />
                  <span className="whitespace-pre-line">{o.address}</span>
                </div>
                {o.phone && (
                  <a
                    href={`tel:${o.phone.replace(/\s/g, "")}`}
                    className="mt-3 flex items-center gap-2 text-sm text-[#7c1d1d] hover:text-[#5a1515]"
                  >
                    <Phone className="w-4 h-4" /> {o.phone}
                  </a>
                )}
                {o.email && (
                  <a
                    href={`mailto:${o.email}`}
                    className="mt-2 flex items-center gap-2 text-sm text-[#7c1d1d] hover:text-[#5a1515]"
                  >
                    <Mail className="w-4 h-4" /> {o.email}
                  </a>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
